import * as React from 'react';
import { Link } from 'react-router-dom';

import { MAX_VIEW_WIDTH_FOR_MOBILE_NAVBAR } from '../utils/constants';

interface renderNavListProps {
  activeTab: string;
  ariaLabel?: string;
  childElement?: JSX.Element;
  handleLinkClick: () => void;
  listClass?: string;
  tabs: {
    [key: string]: {
      label: string;
      url: string;
    };
  };
}

function renderListItem({
  activeTab,
  handleLinkClick,
  i,
  tabLabel,
  tabs
}: {
  activeTab: string;
  handleLinkClick: () => void;
  i: number;
  tabLabel: string;
  tabs: { [key: string]: { label: string; url: string } };
}) {
  const onMobile = window.innerWidth <= MAX_VIEW_WIDTH_FOR_MOBILE_NAVBAR;
  const isActive = activeTab === tabLabel;
  const activeClass = isActive ? 'active' : '';

  if (onMobile) {
    return (
      <li key={i}>
        <Link
          aria-current={isActive ? 'page' : undefined}
          className={`${activeClass} focus-on-dark`}
          onClick={handleLinkClick}
          to={tabs[tabLabel].url}
        >
          {tabLabel}
        </Link>
        <div
          aria-hidden="true"
          className={`checkmark-icon ${activeClass}`}
        />
      </li>
    );
  }
  return (
    <li key={i}>
      <Link
        aria-current={isActive ? 'page' : undefined}
        className={`${activeClass} focus-on-dark`}
        onClick={handleLinkClick}
        to={tabs[tabLabel].url}
      >
        {tabLabel}
      </Link>
    </li>
  );
}

export function renderNavList({
  ariaLabel,
  activeTab,
  childElement,
  handleLinkClick,
  listClass,
  tabs
}: renderNavListProps) {
  return (
    <nav aria-label={ariaLabel}>
      <ul className={listClass}>
        {Object.keys(tabs).map((tabLabel, i) =>
          renderListItem({ activeTab, handleLinkClick, i, tabLabel, tabs })
        )}
        {childElement}
      </ul>
    </nav>
  );
}
